"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import API from "@ym-framework/api-utils";
import { Vue, Component, PropSync } from "vue-property-decorator";
let ItemElementRenewBtn = class extends Vue {
  toRenew() {
    return __async(this, null, function* () {
      try {
        let arr = [];
        arr.push(this._item.oldId);
        yield API.post(
          `api://base.auth/api/v7/payment/virtualdesktop-verification/renew`,
          {
            ids: arr
          }
        );
        this.$router.push({
          name: "payment",
          query: {
            style: "renew"
          },
          params: {
            item: JSON.stringify(this._item)
          }
        });
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
};
__decorateClass([
  PropSync("item")
], ItemElementRenewBtn.prototype, "_item", 2);
ItemElementRenewBtn = __decorateClass([
  Component({})
], ItemElementRenewBtn);
export {
  ItemElementRenewBtn as default
};
